import update from 'immutability-helper';
import { MAX_MOBILE_WIDTH } from '../utils/common.utils';

const initialState = {
  navlist: [],
  inventoryCategories: [], // TODO This is literally only used for FeedbackModal, try to remove it
  appInitializing: true,
  appInitialized: false,
  organizations: [],
  offices: [],
  costCenters: null, // This is null deliberately so we can know the difference between "not loaded" and "empty"
  labels: {},
  windowWidth: 1920, // Don't rely on this, it's not updated 24/7
  isDesktop: true, // This should be
  isMobileFullscreen: false, // This is true when full screen mobile modals are open
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_MUNICIPALITIES':
      return update(state, {
        municipalities: { $set: action.payload },
      });
    case 'SET_OFFICES':
      return update(state, {
        offices: { $set: action.payload },
      });
    case 'RECEIVE_NAV_ITEMS':
      return update(state, {
        navlist: { $set: action.payload },
      });
    case 'SET_APP_INITIALIZING':
      return { ...state, appInitializing: action.payload };
    case 'SET_APP_INITIALIZED':
      return { ...state, appInitialized: action.payload };
    case 'ADD_USER':
      return { ...state, user: action.payload };
    case 'RECEIVE_ORGANIZATIONS':
      return { ...state, [action.payload.orgType]: action.payload.data };
    case 'RECEIVE_COST_CENTERS':
      return { ...state, costCenters: action.payload };
    case 'ORGANIZATION_SELECTED': {
      return {
        ...state,
        selectedOrganization: action.payload,
        showOrganizationModalValidation: action.payload == null,
      };
    }
    case 'VALIDATE_ORGANIZATION_SELECT':
      return { ...state, showOrganizationModalValidation: true };
    case 'SET_WINDOW_INFO':
      return {
        ...state,
        windowWidth: action.payload,
        isDesktop: action.payload > MAX_MOBILE_WIDTH,
      };
    case 'RECEIVE_INVENTORY_CATEGORIES':
      return { ...state, inventoryCategories: action.payload };
    case 'RECEIVE_FORM_MODELS':
      return { ...state, formModels: action.payload };
    case 'RECEIVE_LABELS':
      return { ...state, labels: action.payload };
    case 'SET_MOBILE_FULLSCREEN':
      return { ...state, isMobileFullscreen: action.payload };
    default:
      return state;
  }
}
